import { useState, useEffect, useCallback, useMemo } from 'react';
import { Lease } from '../../types/leases';
import { leasesApi } from '../../api/leasesApi';

interface UseAllLeasesReturn {
    leases: Lease[];
    leasesByBuilding: { [buildingKey: string]: Lease[] };
    loading: boolean;
    error: string | null;
    refresh: () => Promise<void>;
}

/** Every lease, grouped by building — Ekonomi and the tenant list. */
export const useAllLeases = (): UseAllLeasesReturn => {
    const [leases, setLeases] = useState<Lease[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            setLeases(await leasesApi.getAll());
        } catch (err) {
            console.error('Error loading all leases:', err);
            setError('Kunde inte ladda hyresavtal');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    const leasesByBuilding = useMemo(() => {
        const grouped: { [buildingKey: string]: Lease[] } = {};
        for (const lease of leases) {
            (grouped[lease.buildingKey] = grouped[lease.buildingKey] || []).push(lease);
        }
        return grouped;
    }, [leases]);

    return { leases, leasesByBuilding, loading, error, refresh: load };
};
